import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBXqwipJGhKNXXtWx4Lba4RvP0rd8TM80Y',
  authDomain: 'byte-gaming.firebaseapp.com',
  projectId: 'byte-gaming',
  storageBucket: 'byte-gaming.firebasestorage.app',
  messagingSenderId: '360261578948',
  appId: '1:360261578948:web:0a6250ec783d8700c01991',
};

// Primary app: anonymous device identity (persisted in IndexedDB, never overwritten).
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Secondary app: short-lived staff custom token.
// Using a separate app prevents signInWithCustomToken from overwriting the
// persisted anonymous device user — which would cause isPaired=false on reopen.
export const staffApp = initializeApp(firebaseConfig, 'staff');
export const staffAuth = getAuth(staffApp);

if (import.meta.env.DEV || import.meta.env.VITE_USE_EMULATOR === 'true') {
  try {
    const host = window.location.hostname;
    connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
    connectAuthEmulator(staffAuth, `http://${host}:9099`, { disableWarnings: true });
    connectFirestoreEmulator(db, host, 8080);
    connectStorageEmulator(storage, host, 9199);
  } catch {
    // Already connected — hot-reload safe
  }
}

// Enable offline persistence for catalog reads only (no order queuing).
enableIndexedDbPersistence(db).catch(() => {
  // Multi-tab or private browsing: persistence unavailable, continue without.
});
